/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const PackageX = createLucideIcon("package-x", [
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m16.5 14.5 5 5", key: "ozpm51" }],
  ["path", { d: "m16.5 19.5 5-5", key: "syf6b9" }],
  [
    "path",
    {
      d: "M21 10.5V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l.13-.074",
      key: "isw6gs"
    }
  ],
  ["path", { d: "M3.29 7 12 12l8.71-5", key: "19ckod" }],
  ["path", { d: "m7.5 4.27 8.997 5.148", key: "9yrvtv" }]
]);

export { PackageX as default };
//# sourceMappingURL=package-x.js.map
